import React, { useState, useEffect } from 'react';
import './QuickEscape.css';

const QuickEscape = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleEscape = () => {
    // Immediately redirect to Google
    window.location.replace('https://www.google.com');
  };

  return (
    <button
      className={`quick-escape-button ${isMobile ? 'mobile' : 'desktop'}`}
      onClick={handleEscape}
      aria-label="Quick escape - Leave this site immediately"
      title="Quick escape - Leave this site immediately"
    >
      <span className="escape-text-line1">QUICK</span>
      <span className="escape-text-line2">ESCAPE</span>
    </button>
  );
};

export default QuickEscape;